import type { TagProps } from 'antd';
import type { SizeType } from 'antd/lib/config-provider/SizeContext';
import { StyledTag } from './Tag.styles';

interface UITagProps extends TagProps {
  size?: SizeType;
}

function UITag({ size, className, ...props }: UITagProps) {
  let _className = className ?? '';

  if (size) {
    _className += ` ant-tag-${size}`;
  }

  return <StyledTag className={_className} {...props} />;
}

export { UITag as Tag };
export type { UITagProps as TagProps };
